import { useMutation } from 'react-query';
import { network } from 'services/network';

export const mutationFn = (params: QueryParams) => {
    const url = `api/bo/runQsraAnalysis`;
    return network.post(url, params).then((response) => response.data);
};

export const useMutationRunQsraAnalysis = () => {
    return useMutation<string, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

export interface QueryParams {
    numOfSimulations: number;
    riskIds: number[];
    metaDataId: number;
    taskVersionHashCode: string;
}
